module.exports = __webpack_public_path__ + "img/FuelMetrics.bcae091d.png";